import React from 'react'

import Container from '~/components/atoms/Container/Container'
import type { IconTypes } from '~/components/atoms/Icon/Icon'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import Badge from '../Badge/Badge'
import type { PartnerCategories } from '../PartnerCard/PartnerCard'

import styles from './PartnerHeader.module.css'

interface PartnerHeaderProps {
  title: string
  summary?: string
  categories?: PartnerCategories[]
  isAccredited?: boolean
  isTrusted?: boolean
}

export const CategoryLozenge = ({
  category,
  icon,
}: {
  category: PartnerCategories | string
  icon?: IconTypes
  onClick?: () => void
}) => {
  return (
    <div className={styles.category}>
      {icon && (
        <div className={styles.categoryIcon}>
          {' '}
          <Icon type={icon} />
        </div>
      )}
      <Text size={TextSizes.primaryTitleSml} className={styles.categoryName}>
        {typeof category === 'object' && category ? category.name : category}
      </Text>
    </div>
  )
}

const PartnerHeader: React.FC<PartnerHeaderProps> = ({
  title,
  summary,
  categories,
  isAccredited,
  isTrusted,
}) => {
  return (
    <>
      <div className={styles.base}>
        <Container>
          <div className={styles.container}>
            <Text
              Tag="h1"
              size={TextSizes.primaryTitleLrgPlus}
              uppercase
              className={styles.title}
            >
              {title}
            </Text>
            {summary && (
              <Text
                size={TextSizes.secondaryTitleLrg}
                className={styles.summary}
              >
                {summary}
              </Text>
            )}

            <div className={styles.categoriesContainer}>
              <div className={styles.categories}>
                {isAccredited && <Badge type={'accredited'} isLarge />}
                {isTrusted && <Badge type={'trusted'} isLarge />}
                {categories &&
                  categories?.length > 0 &&
                  categories.map((category, idx) => {
                    return (
                      <CategoryLozenge
                        key={`category-${idx}`}
                        category={category}
                        // todo - add action for the filter or something...
                        onClick={() => {
                          // Callback to do something with the category
                          // Aman will likely want to track this event
                          // await multiPostHogEventPusher([
                          //   {
                          //     eventType: 'Partners ${category.name} category  clicked',
                          //   },
                          // ])
                        }}
                      />
                    )
                  })}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}

export default PartnerHeader
